module.exports = __webpack_public_path__ + "img/alsf.280260e5.png";